export default {
    "app.header": "翻訳のサービスボイジャー",
    "about.header": "ボイジャーについて",
    "about.para": "ボイジャーは翻訳と通訳のサービスの中で大立のサービスです。我々３０年以上の経験があり、お客様は翻訳と通訳のサービスに何が探しているちゃんとわかっています。お客様がほしい翻訳を易しく、早く提供しています。",
    "services.header": "サービス",
    "service.one": "連続通訳",
    "service.two": "同時通訳",
    "service.three": "多言語のソーシャルメディアの内容",
    "service.four": "ドキュメントの翻訳",
    "service.five": "公衆衛生の通訳",
    "service.six": "合法的な通訳",
    "prices.header": "値段",
    "prices.para": "翻訳者と通訳者はのサービスが一時間に値段がついています。",
    "translator.para": "翻訳 １時間あたり£９",
    "interpreter.para": "通訳 １時間あたり£１０・£１５（連続・同時）"
};